import React from "react";
import { useSelector } from "react-redux";
import {
	API_PROJECT,
	ROLE_SP_SYSTEM_ADMINISTRATOR,
	ROLE_SP_AWARD_ADMINISTRATOR,
	ROLE_SP_PROPOSAL_ADMINISTRATOR,
	COLUMN_HEADER_KEYS
} from "globals/constants";
import FormNotesView from "components/FormNotesView";
import { useHasRoles } from "hooks";
import { getProject } from "store/actions/project";
import { projectSelectors } from "store/selectors";


const ProjectNotesView = () => {
	const project = useSelector(projectSelectors.project);

	const {
		[ROLE_SP_SYSTEM_ADMINISTRATOR]: isSystemAdmin,
		[ROLE_SP_AWARD_ADMINISTRATOR]: isAwardAdmin,
		[ROLE_SP_PROPOSAL_ADMINISTRATOR]: isProposalAdmin,
	} = useHasRoles([
		ROLE_SP_SYSTEM_ADMINISTRATOR,
		ROLE_SP_AWARD_ADMINISTRATOR,
		ROLE_SP_PROPOSAL_ADMINISTRATOR,
	]);

	const canEditNotes = (isSystemAdmin || isAwardAdmin || isProposalAdmin);


	const formInstance = {
		instance: project,
		instanceId: project.projectId,
		endpoint: API_PROJECT,
		type: COLUMN_HEADER_KEYS.PROJECT
	};

	return (
		<FormNotesView
			formInstance = { formInstance }
			canAddNotes = { canEditNotes }
			canEditNotes = { canEditNotes }
			refreshForm = { getProject }
		/>
	);
};

export default ProjectNotesView;
